import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../emotion-theme";

export const LinkText = styled.span`
  text-decoration: underline;
  color: ${BASE_COLORS.navyBlue};
  :hover {
    cursor: pointer;
    color: ${BASE_COLORS.deepSkyBlue};
    font-weight: 600;
  }
`;
